<template>
  <div id="component-name">
    <button v-bind:class="{active: isActive}" @click="isActive = !isActive">{{isActive}}</button>
  </div>
</template>

<script>
export default {
  name: 'CustomButton',
  data () {
    return {
      isActive: false
    }
  },
  props: [],
  computed: {},
  methods: {
  },
  mounted () {
  },
  components: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/CustomButton.vue